export const iconFontAwesomeMoneyPiggyBank = (
	<i className="fa-solid fa-piggy-bank"></i>
);
